import { render, staticRenderFns } from "./BulkProgress.vue?vue&type=template&id=6c987f04&scoped=true"
import script from "./BulkProgress.vue?vue&type=script&lang=ts"
export * from "./BulkProgress.vue?vue&type=script&lang=ts"
import style0 from "./BulkProgress.vue?vue&type=style&index=0&id=6c987f04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c987f04",
  null
  
)

export default component.exports